import { IntegrationScope } from '../../../../types/responses/Interoperability';

/**
 * Tipos do catálogo da API, num arquivo só para os dois lados importarem sem ciclo:
 * a seção `partner` é escrita à mão (apiCatalog.ts) e a `internal` é gerada do OpenAPI do
 * tenant-cross (apiCatalog.internal.generated.ts).
 */

export type ApiSection = 'partner' | 'internal';

/**
 * Como o endpoint autentica.
 * - INTEGRATION_TOKEN: Authorization: Bearer <token de integração>, com escopo.
 * - TENANT_ID: identidade do tenant no header X-TENANT-ID (mais a sessão, via gateway).
 * - SESSION: só a sessão do dashboard (Authorization), sem tenant no header.
 * - PUBLIC: não exige credencial no controller (ainda passa pelo gateway).
 */
export type ApiAuth = 'INTEGRATION_TOKEN' | 'TENANT_ID' | 'SESSION' | 'PUBLIC';

export type ApiParam = { name: string; description: string; example?: string };

export type ApiEndpoint = {
  section: ApiSection;

  /** Pasta a que o endpoint pertence, para agrupar na tela e na coleção. */
  group: string;

  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

  /** Caminho relativo à base do ambiente. Parâmetros de rota como `:nome`. */
  path: string;

  summary: string;

  auth: ApiAuth;

  /** Escopos exigidos — todos eles. Obrigatório quando auth é INTEGRATION_TOKEN. */
  scopes?: IntegrationScope[];

  pathParams?: ApiParam[];

  query?: ApiParam[];

  /** Cabeçalhos além da autenticação (ex.: X-TENANT-ID). */
  headers?: ApiParam[];

  /** Corpo de exemplo (placeholders, nunca credencial real). */
  bodyExample?: string;

  /** Um exemplo de resposta, abreviado para caber na tela. */
  responseExample?: string;
};

/** Métodos que alteram estado — o Try it pede confirmação antes de disparar. */
export const isMutating = (endpoint: ApiEndpoint): boolean => endpoint.method !== 'GET';
